export const material_symbols = [
  'search',
  'home',
  'menu',
  'close',
  'settings',
  'done',
  'expand_more',
  'check_circle',
  'favorite',
  'add',
  'delete',
  'arrow_back',
  'star',
  'chevron_right',
  'logout',
  'arrow_forward_ios',
  'add_circle',
  'cancel',
  'arrow_back_ios',
  'arrow_forward',
  'arrow_drop_down',
  'more_vert',
  'check',
  'check_box',
  'toggle_on',
  'grade',
  'open_in_new',
  'refresh',
  'check_box_outline_blank',
  'login',
  'chevron_left',
  'expand_less',
  'radio_button_unchecked',
  'more_horiz',
  'apps',
  'download',
  'arrow_right_alt',
  'radio_button_checked',
  'remove',
  'bolt',
  'toggle_off',
  'arrow_upward',
  'filter_list',
  'delete_forever',
  'autorenew',
  'key',
  'sync',
  'arrow_downward',
  'block',
  'sort',
  'add_box',
  'arrow_back_ios_new',
  'restart_alt',
  'shopping_cart_checkout',
  'menu_open',
  'expand_circle_down',
  'backspace',
  'undo',
  'arrow_circle_right',
  'done_all',
  'arrow_right',
  'do_not_disturb_on',
  'open_in_full',
  'manage_search',
  'double_arrow',
  'sync_alt',
  'zoom_in',
  'done_outline',
  'drag_indicator',
  'fullscreen',
  'keyboard_double_arrow_right',
  'star_half',
  'ios_share',
  'settings_accessibility',
  'arrow_drop_up',
  'reply',
  'exit_to_app',
  'unfold_more',
  'library_add',
  'cached',
  'terminal',
  'select_check_box',
  'change_circle',
  'disabled_by_default',
  'swap_horiz',
  'swap_vert',
  'close_fullscreen',
  'app_registration',
  'download_for_offline',
  'arrow_circle_left',
  'arrow_circle_up',
  'file_open',
  'minimize',
  'dataset',
  'open_with',
  'keyboard_double_arrow_left',
  'add_task',
  'start',
  'keyboard_voice',
  'keyboard_double_arrow_down',
  'create_new_folder',
  'forward',
  'downloading',
  'settings_applications',
  'upload',
  'compare_arrows',
  'redo',
  'publish',
  'zoom_out',
  'arrow_left',
  'html',
  'token',
  'switch_access_shortcut',
  'fullscreen_exit',
  'arrow_circle_down',
  'sort_by_alpha',
  'delete_sweep',
  'indeterminate_check_box',
  'first_page',
  'view_timeline',
  'keyboard_double_arrow_up',
  'settings_backup_restore',
  'assistant_navigation',
  'arrow_drop_down_circle',
  'sync_problem',
  'clear_all',
  'density_medium',
  'heart_plus',
  'expand',
  'filter_alt_off',
  'last_page',
  'subdirectory_arrow_right',
  'arrow_outward',
  'unfold_less',
  'download_done',
  '123',
  'swipe_left',
  'saved_search',
  'system_update_alt',
  'place_item',
  'search_off',
  'output',
  'maximize',
  'javascript',
  'swipe_up',
  'fit_screen',
  'select_all',
  'hide_source',
  'dynamic_form',
  'swipe_right',
  'check_small',
  'switch_access_shortcut_add',
  'browse_gallery',
  'density_small',
  'css',
  'assistant_direction',
  'file_download_done',
  'move_up',
  'youtube_searched_for',
  'swap_horizontal_circle',
  'data_thresholding',
  'install_mobile',
  'abc',
  'dataset_linked',
  'move_down',
  'restore_from_trash',
  'enable',
  'install_desktop',
  'keyboard_command_key',
  'view_kanban',
  'browse_activity',
  'reply_all',
  'switch_left',
  'compress',
  'swipe_down',
  'swap_vertical_circle',
  'remove_done',
  'apps_outage',
  'filter_list_off',
  'star_rate',
  'hide',
  'switch_right',
  'swipe_vertical',
  'sync_disabled',
  'more_up',
  'pinch',
  'keyboard_control_key',
  'eject',
  'key_off',
  'php',
  'subdirectory_arrow_left',
  'view_cozy',
  'transcribe',
  'do_not_disturb_off',
  'send_time_extension',
  'width_normal',
  'view_comfy_alt',
  'heart_minus',
  'share_reviews',
  'width_full',
  'unfold_more_double',
  'file_download_off',
  'view_compact_alt',
  'extension_off',
  'open_in_new_off',
  'check_indeterminate_small',
  'more_down',
  'width_wide',
  'repartition',
  'density_large',
  'swipe_left_alt',
  'swipe_down_alt',
  'swipe_up_alt',
  'swipe_right_alt',
  'cycle',
  'unfold_less_double',
  'progress_activity',
  'keyboard_option_key',
  'hls',
  'hls_off',
  'file_upload_off',
  'expand_content',
  'rebase',
  'expand_all',
  'collapse_all',
  'rebase_edit',
  'quick_reference_all',
  'arrow_split',
  'stat_0',
  'deployed_code',
  'empty_dashboard',
  'stack',
  'acute',
  'arrow_upward_alt',
  'left_click',
  'switches',
  'data_check',
  'arrow_downward_alt',
  'directory_sync',
  'data_alert',
  'quick_reference',
  'page_info',
  'sync_saved_locally',
  'cards',
  'side_navigation',
  'clock_loader_60',
  'data_info_alert',
  'question_exchange',
  'bubble',
  'point_scan',
  'steppers',
  'move_item',
  'stack_star',
  'arrow_left_alt',
  'preliminary',
  'stat_3',
  'captive_portal',
  'search_check',
  'unknown_med',
  'star_rate_half',
  'toolbar',
  'right_panel_close',
  'clock_loader_10',
  'new_window',
  'rule_settings',
  'sweep',
  'right_panel_open',
  'responsive_layout',
  'step',
  'drag_pan',
  'patient_list',
  'clock_loader_40',
  'expand_circle_right',
  'share_windows',
  'stat_minus_1',
  'arrow_insert',
  'input_circle',
  'left_panel_close',
  'page_control',
  'dialogs',
  'expand_circle_up',
  'heart_check',
  'move_group',
  'stat_2',
  'all_match',
  'capture',
  'clock_loader_80',
  'stat_minus_2',
  'left_panel_open',
  'clock_loader_90',
  'step_into',
  'bottom_panel_open',
  'resize',
  'stack_off',
  'stat_1',
  'deployed_code_update',
  'dropdown',
  'magnification_small',
  'partner_reports',
  'radio_button_partial',
  'magnification_large',
  'pip',
  'bottom_navigation',
  'clock_loader_20',
  'event_list',
  'sliders',
  'buttons_alt',
  'linked_services',
  'stacks',
  'tabs',
  'arrow_range',
  'bottom_drawer',
  'chronic',
  'drag_click',
  'go_to_line',
  'right_click',
  'shelf_position',
  'stat_minus_3',
  'arrow_and_edge',
  'bottom_sheets',
  'chip_extraction',
  'iframe',
  'open_in_new_down',
  'step_over',
  'unknown_5',
  'ripples',
  'toast',
  'move_selection_left',
  'bottom_right_click',
  'output_circle',
  'reopen_window',
  'subheader',
  'app_badging',
  'arrow_or_edge',
  'chips',
  'switch_access',
  'arrows_outward',
  'step_out',
  'arrow_top_left',
  'back_to_tab',
  'pip_exit',
  'deployed_code_history',
  'error_med',
  'key_vertical',
  'amend',
  'bubbles',
  'jump_to_element',
  'move_selection_right',
  'move_selection_up',
  'arrow_top_right',
  'position_bottom_right',
  'position_top_right',
  'deployed_code_alert',
  'highlight_mouse_cursor',
  'shelf_auto_hide',
  'action_key',
  'bottom_app_bar',
  'bottom_panel_close',
  'iframe_off',
  'collapse_content',
  'position_bottom_left',
  'close_small',
  'move_selection_down',
  'switch_access_2',
  'settings_heart',
  'upload_2',
  'deployed_code_account',
  'download_2',
  'highlight_keyboard_focus',
  'highlight_text_cursor',
  'person',
  'group',
  'share',
  'thumb_up',
  'groups',
  'public',
  'person_add',
  'handshake',
  'support_agent',
  'face',
  'sentiment_satisfied',
  'rocket_launch',
  'group_add',
  'workspace_premium',
  'psychology',
  'diversity_3',
  'emoji_objects',
  'water_drop',
  'eco',
  'travel_explore',
  'pets',
  'mood',
  'sunny',
  'quiz',
  'health_and_safety',
  'sentiment_dissatisfied',
  'sentiment_very_satisfied',
  'military_tech',
  'thumb_down',
  'gavel',
  'recycling',
  'diamond',
  'monitor_heart',
  'emoji_people',
  'diversity_1',
  'workspaces',
  'vaccines',
  'compost',
  'forest',
  'recommend',
  'waving_hand',
  'person_remove',
  'wc',
  'sentiment_neutral',
  'medication',
  'sentiment_very_dissatisfied',
  'group_work',
  'diversity_2',
  'front_hand',
  'psychology_alt',
  'cruelty_free',
  'man',
  'medical_information',
  'coronavirus',
  'add_reaction',
  'rocket',
  'female',
  'potted_plant',
  'emoji_nature',
  'rainy',
  'person_off',
  'cookie',
  'connect_without_contact',
  'woman',
  'mood_bad',
  'male',
  'bedtime',
  'communication',
  'groups_2',
  'solar_power',
  'thunderstorm',
  'thumbs_up_down',
  'partly_cloudy_day',
  'emoji_flags',
  'masks',
  'hive',
  'sentiment_extremely_dissatisfied',
  'heart_broken',
  'clear_day',
  'boy',
  'whatshot',
  'cloudy_snowing',
  'emoji_food_beverage',
  'wind_power',
  'emoji_transportation',
  'elderly',
  'face_6',
  'reduce_capacity',
  'sick',
  'face_3',
  'pregnant_woman',
  'groups_3',
  'bloodtype',
  'skull',
  'egg',
  'group_remove',
  'medication_liquid',
  'co2',
  'clear_night',
  'emoji_events',
  'weight',
  'follow_the_signs',
  'face_4',
  'elderly_woman',
  'oil_barrel',
  'transgender',
  'sanitizer',
  'clean_hands',
  'person_2',
  'bring_your_own_ip',
  'public_off',
  'face_2',
  'routine',
  'social_distance',
  'sign_language',
  'south_america',
  'sunny_snowing',
  'emoji_symbols',
  'garden_cart',
  'flood',
  'face_5',
  'egg_alt',
  'cyclone',
  'girl',
  'person_4',
  'dentistry',
  'tsunami',
  'group_off',
  'outdoor_garden',
  'partly_cloudy_night',
  'severe_cold',
  'snowing',
  'person_3',
  'tornado',
  'safety_divider',
  'vaping_rooms',
  'landslide',
  'foggy',
  'woman_2',
  'no_adult_content',
  'volcano',
  '6_ft_apart',
  'blind',
  'man_2',
  '18_up_rating',
  'not_accessible',
  'vape_free',
  'partner_exchange',
  'man_4',
  'radiology',
  'rib_cage',
  'hand_bones',
  'bedtime_off',
  'rheumatology',
  'man_3',
  'orthopedics',
  'tibia',
  'skeleton',
  'humerus',
  'foot_bones',
  'communities',
  'agender',
  'femur',
  'tibia_alt',
  'diversity_4',
  'femur_alt',
  'cognition',
  'humerus_alt',
  'ulna_radius',
  'digital_wellbeing',
  'ulna_radius_alt',
  'specific_gravity',
  'neurology',
  'person_raised_hand',
  'labs',
  'psychiatry',
  'eyeglasses',
  'footprint',
  'crowdsource',
  'breastfeeding',
  'globe',
  'social_leaderboard',
  'vital_signs',
  'globe_asia',
  'nutrition',
  'strategy',
  'tactic',
  'demography',
  'stethoscope',
  'mystery',
  'clinical_notes',
  'sentiment_calm',
  'sentiment_excited',
  'taunt',
  'conditions',
  'sentiment_stressed',
  'lab_research',
  'globe_uk',
  'chess',
  'pill',
  'folded_hands',
  'crossword',
  'genetics',
  'sentiment_sad',
  'home_health',
  'wrist',
  'altitude',
  'glucose',
  'not_accessible_forward',
  'cardiology',
  'cookie_off',
  'deceased',
  'domino_mask',
  'falling',
  'person_alert',
  'prescriptions',
  'mountain_flag',
  'share_off',
  'weather_hail',
  'barefoot',
  'microbiology',
  'sentiment_content',
  'weather_mix',
  'cheer',
  'recent_patient',
  'earthquake',
  'person_check',
  'emoticon',
  'sentiment_frustrated',
  'mist',
  'person_apron',
  'sword_rose',
  'prayer_times',
  'water_bottle',
  'raven',
  'helicopter',
  'lab_panel',
  'metabolism',
  'playing_cards',
  'dermatology',
  'dew_point',
  'sentiment_worried',
  'bomb',
  'ent',
  'pulmonology',
  'explosion',
  'body_system',
  'comic_bubble',
  'editor_choice',
  'infrared',
  'oral_disease',
  'oxygen_saturation',
  'destruction',
  'nephrology',
  'person_cancel',
  'stethoscope_check',
  'ward',
  'water_lux',
  'humidity_percentage',
  'water_ph',
  'allergies',
  'blood_pressure',
  'manga',
  'pregnancy',
  'stethoscope_arrow',
  'water_voc',
  'allergy',
  'mixture_med',
  'ophthalmology',
  'outpatient',
  'pediatrics',
  'rainy_snow',
  'snowing_heavy',
  'water_do',
  'wounds_injuries',
  'body_fat',
  'gastroenterology',
  'gynecology',
  'immunology',
  'oncology',
  'respiratory_rate',
  'short_stay',
  'symptoms',
  'syringe',
  'water_bottle_large',
  'water_orp',
  'admin_meds',
  'candle',
  'congenital',
  'endocrinology',
  'fluid_balance',
  'hematology',
  'inpatient',
  'moving_beds',
  'procedure',
  'pulse_alert',
  'rainy_light',
  'salinity',
  'water_ec',
  'family_star',
  'fluid',
  'fluid_med',
  'kid_star',
  'medical_mask',
  'outpatient_med',
  'pill_off',
  'rainy_heavy',
  'surgical',
  'total_dissolved_solids',
  'urology',
  'account_circle',
  'info',
  'visibility',
  'calendar_month',
  'schedule',
  'help',
  'warning',
  'language',
  'lock',
  'error',
  'visibility_off',
  'verified',
  'manage_accounts',
  'history',
  'task_alt',
  'event',
  'bookmark',
  'calendar_today',
  'question_mark',
  'lightbulb',
  'fingerprint',
  'category',
  'update',
  'lock_open',
  'priority_high',
  'code',
  'build',
  'date_range',
  'supervisor_account',
  'upload_file',
  'event_available',
  'ads_click',
  'today',
  'touch_app',
  'pending',
  'preview',
  'stars',
  'new_releases',
  'celebration',
  'bug_report',
  'account_box',
  'translate',
  'how_to_reg',
  'push_pin',
  'alarm',
  'edit_calendar',
  'edit_square',
  'label',
  'extension',
  'event_note',
  'record_voice_over',
  'rate_review',
  'web',
  'hourglass_empty',
  'published_with_changes',
  'support',
  'notification_important',
  'accessibility_new',
  'help_center',
  'bookmarks',
  'pan_tool_alt',
  'dangerous',
  'supervised_user_circle',
  'interests',
  'collections_bookmark',
  'all_inclusive',
  'rule',
  'priority',
  'change_history',
  'event_upcoming',
  'build_circle',
  'api',
  'wysiwyg',
  'pan_tool',
  'hotel_class',
  'circle_notifications',
  'manage_history',
  'web_asset',
  'accessible',
  'upgrade',
  'input',
  'bookmark_add',
  'lock_reset',
  'event_busy',
  'model_training',
  'more_time',
  'flutter_dash',
  'save_as',
  'backup',
  'dynamic_feed',
  'accessibility',
  'alarm_on',
  'pageview',
  'home_app_logo',
  'label_important',
  'perm_contact_calendar',
  'approval',
  'square_foot',
  'history_toggle_off',
  'more',
  'swipe',
  'component_exchange',
  'event_repeat',
  'bookmark_added',
  'app_shortcut',
  'unpublished',
  'open_in_browser',
  'notification_add',
  'offline_bolt',
  'no_accounts',
  'free_cancellation',
  'background_replace',
  'running_with_errors',
  'webhook',
  'anchor',
  '3d_rotation',
  'lock_person',
  'new_label',
  'lock_clock',
  'accessible_forward',
  'auto_delete',
  'add_alert',
  'domain_verification',
  'outbound',
  'hand_gesture',
  'tab',
  'gesture',
  'chrome_reader_mode',
  'settings_power',
  'online_prediction',
  'lightbulb_circle',
  'edit_notifications',
  'find_replace',
  'offline_pin',
  'backup_table',
  'ad_units',
  'wifi_protected_setup',
  'http',
  'bookmark_remove',
  'alarm_add',
  'pinch_zoom_out',
  'on_device_training',
  'snooze',
  'batch_prediction',
  'target',
  'code_off',
  'feedback',
  'pinch_zoom_in',
  'commit',
  'hourglass_disabled',
  'settings_overscan',
  'polymer',
  'youtube_activity',
  'logo_dev',
  'time_auto',
  'voice_over_off',
  'alarm_off',
  'person_add_disabled',
  'manufacturing',
  'update_disabled',
  'timer_10_alt_1',
  'rounded_corner',
  'label_off',
  'timer_3_alt_1',
  'all_out',
  'tab_unselected',
  'rsvp',
  'web_asset_off',
  'pin_invoke',
  'web_traffic',
  'pin_end',
  'code_blocks',
  'arrow_selector_tool',
  'approval_delegation',
  'contacts_product',
  'developer_guide',
  'flutter',
  'license',
  'reminder',
  'feature_search',
  'lists',
  'problem',
  'user_attributes',
  'browse',
  'sdk',
  'award_star',
  'visibility_lock',
  'release_alert',
  'data_loss_prevention',
  'ad_group',
  'select_window',
  'settings_account_box',
  'pan_zoom',
  'lock_open_right',
  'search_hands_free',
  'ad',
  'draft_orders',
  'ad_group_off',
  'account_child_invert',
  'account_child',
  'shadow',
  'add_ad',
  'circles_ext',
  'gesture_select',
  'calendar_clock',
  'hourglass',
  'bookmark_manager',
  'watch_screentime',
  'info_i',
  'account_circle_off',
  'shift',
  'ad_off',
  'indeterminate_question_box',
  'select_window_off',
  'unlicense',
  'alarm_smart_wake',
  'circles',
  'water_lock',
  'help_clinic',
  'scrollable_header',
  'warning_off',
  'supervised_user_circle_off',
  'preview_off',
  'domain_verification_off',
  'measuring_tape',
  'shift_lock',
  'delete_history',
  'shadow_add',
  'shadow_minus',
  'mail',
  'call',
  'notifications',
  'send',
  'chat',
  'link',
  'forum',
  'inventory_2',
  'phone_in_talk',
  'chat_bubble',
  'contact_support',
  'notifications_active',
  'alternate_email',
  'sms',
  'comment',
  'power_settings_new',
  'hub',
  'person_search',
  'import_contacts',
  'contacts',
  'contact_mail',
  'live_help',
  'forward_to_inbox',
  'reviews',
  'mark_email_unread',
  'lan',
  'hourglass_top',
  'contact_phone',
  'mode_comment',
  'inbox',
  'drafts',
  'outgoing_mail',
  'hourglass_bottom',
  'mark_email_read',
  'link_off',
  'calendar_add_on',
  'add_comment',
  'phone_enabled',
  'g_translate',
  'speaker_notes',
  'perm_phone_msg',
  'co_present',
  'notifications_off',
  'call_end',
  'topic',
  'cell_tower',
  'mark_chat_unread',
  'schedule_send',
  'dialpad',
  'call_made',
  'satellite_alt',
  'mark_unread_chat_alt',
  'unarchive',
  '3p',
  'cancel_presentation',
  'mark_as_unread',
  'move_to_inbox',
  'attach_email',
  'next_plan',
  'phonelink_ring',
  'unsubscribe',
  'phone_callback',
  'call_received',
  'settings_phone',
  'call_split',
  'present_to_all',
  'add_call',
  'markunread_mailbox',
  'all_inbox',
  'voice_chat',
  'phone_forwarded',
  'mail_lock',
  'attribution',
  'voicemail',
  'duo',
  'contact_emergency',
  'mark_chat_read',
  'upcoming',
  'phone_disabled',
  'swap_calls',
  'outbox',
  'phonelink_lock',
  'spoke',
  'picture_in_picture_alt',
  'cancel_schedule_send',
  'ring_volume',
  'notifications_paused',
  'quickreply',
  'phone_missed',
  'comment_bank',
  'chat_add_on',
  'send_and_archive',
  'picture_in_picture',
  'phonelink_erase',
  'settings_bluetooth',
  'comments_disabled',
  'video_chat',
  'score',
  'pause_presentation',
  'speaker_phone',
  'cell_wifi',
  'speaker_notes_off',
  'auto_read_play',
  'mms',
  'call_merge',
  'play_for_work',
  'call_missed_outgoing',
  'call_missed',
  'wifi_channel',
  'calendar_apps_script',
  'phone_paused',
  'rtt',
  'auto_read_pause',
  'phone_locked',
  'wifi_calling',
  'chat_apps_script',
  'dialer_sip',
  'nat',
  'sip',
  'phone_bluetooth_speaker',
  'e911_avatar',
  'inbox_customize',
  'stacked_email',
  'business_messages',
  'tooltip',
  'for_you',
  'chat_error',
  'notification_multiple',
  'chat_paste_go',
  'ods',
  'picture_in_picture_small',
  'call_quality',
  'picture_in_picture_off',
  'call_log',
  'chat_info',
  'signal_cellular_add',
  'outbox_alt',
  'network_intelligence_update',
  'notifications_unread',
  'odt',
  'phonelink_ring_off',
  'network_intelligence_history',
  'stacked_inbox',
  'wifi_add',
  'network_manage',
  'picture_in_picture_medium',
  'wifi_proxy',
  'picture_in_picture_center',
  'picture_in_picture_large',
  'picture_in_picture_mobile',
  'edit',
  'photo_camera',
  'filter_alt',
  'image',
  'navigate_next',
  'tune',
  'timer',
  'picture_as_pdf',
  'circle',
  'palette',
  'add_a_photo',
  'photo_library',
  'navigate_before',
  'auto_stories',
  'add_photo_alternate',
  'brush',
  'imagesmode',
  'nature',
  'flash_on',
  'wb_sunny',
  'camera',
  'looks_one',
  'straighten',
  'landscape',
  'timelapse',
  'slideshow',
  'grid_on',
  'rotate_right',
  'crop_square',
  'adjust',
  'crop_free',
  'style',
  'aspect_ratio',
  'brightness_6',
  'photo',
  'nature_people',
  'filter_vintage',
  'image_search',
  'crop',
  'blur_on',
  'center_focus_strong',
  'contrast',
  'compare',
  'looks_two',
  'rotate_left',
  'colorize',
  'flare',
  'filter_none',
  'wb_incandescent',
  'filter_drama',
  'healing',
  'wb_twilight',
  'looks_3',
  'brightness_5',
  'invert_colors',
  'animation',
  'lens',
  'opacity',
  'incomplete_circle',
  'broken_image',
  'filter_center_focus',
  'add_to_photos',
  'brightness_4',
  'flash_off',
  'auto_awesome_motion',
  'flip',
  'center_focus_weak',
  'flip_camera_android',
  'mic_external_on',
  'lens_blur',
  'grain',
  'no_photography',
  'details',
  'panorama',
  'web_stories',
  'gif_box',
  'flaky',
  'dehaze',
  'exposure_plus_1',
  'loupe',
  'settings_brightness',
  'auto_awesome_mosaic',
  'looks_4',
  'texture',
  'filter_1',
  'flip_camera_ios',
  'timer_off',
  'panorama_fish_eye',
  'brightness_1',
  'filter',
  'view_compact',
  'control_point_duplicate',
  'photo_camera_front',
  'brightness_7',
  'transform',
  'photo_album',
  'view_comfy',
  'linked_camera',
  'crop_16_9',
  'hide_image',
  'looks',
  'looks_5',
  'exposure',
  'rotate_90_degrees_ccw',
  'filter_hdr',
  'gif',
  'brightness_3',
  'hdr_strong',
  'leak_add',
  'gradient',
  'hdr_auto',
  'crop_7_5',
  'vrpano',
  'crop_portrait',
  'camera_roll',
  'motion_photos_auto',
  'blur_circular',
  'rotate_90_degrees_cw',
  'photo_size_select_small',
  'brightness_2',
  'shutter_speed',
  'looks_6',
  'camera_front',
  'flash_auto',
  'filter_2',
  'crop_landscape',
  'filter_tilt_shift',
  'deblur',
  'monochrome_photos',
  'night_sight_auto',
  'motion_photos_paused',
  'crop_5_4',
  'filter_4',
  'hdr_weak',
  'filter_3',
  'crop_rotate',
  'tonality',
  'crop_3_2',
  'ev_shadow',
  'fluorescent',
  'switch_camera',
  'photo_frame',
  'exposure_zero',
  'photo_size_select_large',
  'macro_off',
  'filter_frames',
  'party_mode',
  'raw_on',
  'motion_blur',
  'filter_b_and_w',
  'exposure_plus_2',
  'photo_camera_back',
  'blur_linear',
  'exposure_neg_1',
  'motion_photos_off',
  'wb_iridescent',
  'face_retouching_off',
  'switch_video',
  'panorama_horizontal',
  'filter_5',
  'blur_medium',
  'invert_colors_off',
  'filter_7',
  'burst_mode',
  'panorama_photosphere',
  'hdr_on',
  'grid_off',
  'filter_9_plus',
  'timer_10',
  'filter_8',
  'blur_short',
  'dirty_lens',
  'filter_9',
  'wb_shade',
  'no_flash',
  'filter_6',
  'image_aspect_ratio',
  'trail_length',
  'exposure_neg_2',
  'vignette',
  'timer_3',
  'leak_remove',
  'blur_off',
  '60fps_select',
  'perm_camera_mic',
  '30fps_select',
  'trail_length_medium',
  'camera_rear',
  'mic_external_off',
  'trail_length_short',
  'panorama_vertical',
  'night_sight_auto_off',
  'autofps_select',
  'panorama_wide_angle',
  'hdr_enhanced_select',
  'mp',
  'hdr_off',
  '24mp',
  'hdr_on_select',
  '22mp',
  '10mp',
  '12mp',
  'hdr_plus',
  '18mp',
  'hdr_auto_select',
  'raw_off',
  'wb_auto',
  '9mp',
  '13mp',
  'hevc',
  '20mp',
  '5mp',
  '7mp',
  '15mp',
  'hdr_off_select',
  '16mp',
  '19mp',
  '2mp',
  '14mp',
  '23mp',
  '8mp',
  '3mp',
  '6mp',
  '11mp',
  '21mp',
  '4mp',
  '17mp',
  'gallery_thumbnail',
  'masked_transitions',
  'motion_photos_on',
  'settings_b_roll',
  'vr180_create2d',
  'settings_photo_camera',
  'photo_prints',
  'settings_video_camera',
  'planner_banner_ad_pt',
  'settings_panorama',
  'settings_timelapse',
  'settings_night_sight',
  'unknown_2',
  'settings_motion_mode',
  'motion_mode',
  'settings_cinematic_blur',
  'vr180_create2d_off',
  'filter_retrolux',
  '50mp',
  'background_dot_large',
  'background_grid_small',
  'photo_auto_merge',
  'high_res',
  'settings_slow_motion',
  'shutter_speed_add',
  'transition_fade',
  'macro_auto',
  'texture_add',
  'crop_9_16',
  'background_dot_small',
  'ev_shadow_add',
  'high_density',
  'low_density',
  'shutter_speed_minus',
  'texture_minus',
  'transition_dissolve',
  'transition_slide',
  'contrast_rtl_off',
  'ev_shadow_minus',
  'hdr_plus_off',
  'transition_push',
  'transition_chop',
  'shopping_cart',
  'payments',
  'shopping_bag',
  'monitoring',
  'credit_card',
  'receipt_long',
  'attach_money',
  'storefront',
  'database',
  'trending_up',
  'sell',
  'account_balance',
  'work',
  'paid',
  'account_balance_wallet',
  'analytics',
  'query_stats',
  'store',
  'savings',
  'monetization_on',
  'calculate',
  'qr_code_scanner',
  'bar_chart',
  'account_tree',
  'add_shopping_cart',
  'receipt',
  'redeem',
  'currency_exchange',
  'trending_flat',
  'shopping_basket',
  'qr_code_2',
  'domain',
  'precision_manufacturing',
  'qr_code',
  'leaderboard',
  'corporate_fare',
  'timeline',
  'insert_chart',
  'currency_rupee',
  'wallet',
  'show_chart',
  'work_history',
  'euro',
  'meeting_room',
  'credit_score',
  'barcode_scanner',
  'pie_chart',
  'loyalty',
  'copyright',
  'conversion_path',
  'barcode',
  'trending_down',
  'track_changes',
  'price_check',
  'euro_symbol',
  'schema',
  'add_business',
  'add_card',
  'card_membership',
  'currency_bitcoin',
  'price_change',
  'production_quantity_limits',
  'donut_large',
  'tenancy',
  'data_exploration',
  'bubble_chart',
  'donut_small',
  'contactless',
  'money',
  'stacked_line_chart',
  'stacked_bar_chart',
  'toll',
  'money_off',
  'cases',
  'currency_yen',
  'currency_pound',
  'area_chart',
  'atr',
  'remove_shopping_cart',
  'room_preferences',
  'add_chart',
  'shop',
  'domain_add',
  'grouped_bar_chart',
  'card_travel',
  'legend_toggle',
  'scatter_plot',
  'credit_card_off',
  'mediation',
  'ssid_chart',
  'candlestick_chart',
  'waterfall_chart',
  'full_stacked_bar_chart',
  'currency_ruble',
  'domain_disabled',
  'strikethrough_s',
  'shop_two',
  'atm',
  'next_week',
  'multiline_chart',
  'currency_lira',
  'currency_yuan',
  'no_meeting_room',
  'troubleshoot',
  'shoppingmode',
  'currency_franc',
  'finance_mode',
  'data_table',
  'source_environment',
  'finance',
  'bar_chart_4_bars',
  'orders',
  'bid_landscape',
  'enterprise',
  'contactless_off',
  'chart_data',
  'podium',
  'universal_currency_alt',
  'conveyor_belt',
  'planner_review',
  'family_history',
  'flowsheet',
  'order_approve',
  'energy',
  'network_node',
  'quick_reorder',
  'checkbook',
  'universal_currency',
  'send_money',
  'box',
  'mintmark',
  'forklift',
  'inactive_order',
  'qr_code_2_add',
  'box_add',
  'front_loader',
  'pallet',
  'mitre',
  'enterprise_off',
  'trolley',
  'bid_landscape_disabled',
  'barcode_reader',
  'work_update',
  'conversion_path_off',
  'order_play',
  'work_alert',
  'box_edit',
  'credit_card_heart',
  'credit_card_gear',
  'pin_drop',
  'location_on',
  'map',
  'home_pin',
  'explore',
  'restaurant',
  'flag',
  'my_location',
  'local_fire_department',
  'person_pin_circle',
  'local_mall',
  'near_me',
  'where_to_vote',
  'business_center',
  'east',
  'restaurant_menu',
  'handyman',
  'factory',
  'local_library',
  'home_work',
  'medical_services',
  'layers',
  'local_activity',
  'share_location',
  'emergency',
  'north_east',
  'add_location',
  'fastfood',
  'navigation',
  'warehouse',
  'person_pin',
  'local_parking',
  'home_repair_service',
  'local_hospital',
  'local_police',
  'south',
  'zoom_out_map',
  'location_searching',
  'local_florist',
  'location_away',
  'crisis_alert',
  'west',
  'local_gas_station',
  'park',
  'maps_ugc',
  'cleaning_services',
  'local_atm',
  '360',
  'package',
  'electrical_services',
  'flag_circle',
  'north',
  'add_location_alt',
  'directions',
  'fmd_bad',
  'theater_comedy',
  'local_drink',
  'location_home',
  'local_pizza',
  'not_listed_location',
  'local_post_office',
  'wine_bar',
  'beenhere',
  'signpost',
  'local_convenience_store',
  'alt_route',
  'tour',
  'traffic',
  'trip_origin',
  'church',
  'local_laundry_service',
  'safety_check',
  'ev_station',
  'takeout_dining',
  'moving',
  'zoom_in_map',
  'soup_kitchen',
  'pest_control',
  'stadium',
  'transfer_within_a_station',
  'location_off',
  'connecting_airports',
  'wrong_location',
  'multiple_stop',
  'edit_location',
  'plumbing',
  'mode_of_travel',
  'minor_crash',
  'south_east',
  'local_pharmacy',
  'add_road',
  'fire_truck',
  'castle',
  'dry_cleaning',
  'set_meal',
  'baby_changing_station',
  'edit_location_alt',
  'layers_clear',
  'north_west',
  'mosque',
  'edit_attributes',
  'local_car_wash',
  'run_circle',
  'transit_enterexit',
  'sos',
  'satellite',
  'edit_road',
  'south_west',
  'streetview',
  'add_home',
  'kebab_dining',
  'airline_stops',
  'fire_hydrant',
  'local_see',
  'assist_walker',
  'add_home_work',
  'flight_class',
  'remove_road',
  'no_meals',
  'synagogue',
  'fort',
  'temple_buddhist',
  'location_disabled',
  'compass_calibration',
  'temple_hindu',
  'explore_off',
  'pest_control_rodent',
  'directions_alt',
  'near_me_disabled',
  'pergola',
  'directions_off',
  'things_to_do',
  'pet_supplies',
  'directions_alt_off',
  'explore_nearby',
  'package_2',
  'universal_local',
  'file_map',
  'moved_location',
  'move_location',
  'safety_check_off',
  'moving_ministry',
  'move',
  'description',
  'content_copy',
  'dashboard',
  'edit_note',
  'menu_book',
  'grid_view',
  'list',
  'folder',
  'list_alt',
  'inventory',
  'folder_open',
  'article',
  'fact_check',
  'attach_file',
  'format_list_bulleted',
  'assignment',
  'task',
  'checklist',
  'cloud_upload',
  'draft',
  'summarize',
  'cloud',
  'draw',
  'feed',
  'newspaper',
  'view_list',
  'file_copy',
  'note_add',
  'border_color',
  'book',
  'history_edu',
  'design_services',
  'pending_actions',
  'format_quote',
  'post_add',
  'request_quote',
  'cloud_download',
  'drag_handle',
  'table',
  'contact_page',
  'archive',
  'space_dashboard',
  'content_paste',
  'percent',
  'attachment',
  'assignment_ind',
  'format_list_numbered',
  'assignment_turned_in',
  'tag',
  'table_chart',
  'dashboard_customize',
  'sticky_note_2',
  'text_fields',
  'format_bold',
  'reorder',
  'integration_instructions',
  'find_in_page',
  'text_snippet',
  'note',
  'document_scanner',
  'checklist_rtl',
  'note_alt',
  'edit_document',
  'cloud_sync',
  'table_rows',
  'perm_media',
  'cloud_done',
  'title',
  'table_view',
  'content_cut',
  'data_object',
  'notes',
  'cut',
  'subject',
  'functions',
  'format_italic',
  'content_paste_search',
  'format_color_fill',
  'folder_shared',
  'plagiarism',
  'horizontal_rule',
  'file_present',
  'folder_copy',
  'cloud_off',
  'format_paint',
  'ballot',
  'team_dashboard',
  'format_align_left',
  'view_column',
  'add_link',
  'difference',
  'read_more',
  'view_agenda',
  'format_size',
  'format_underlined',
  'toc',
  'vertical_align_top',
  'height',
  'vertical_align_bottom',
  'view_week',
  'copy_all',
  'drive_folder_upload',
  'assignment_late',
  'format_color_text',
  'low_priority',
  'drive_file_move',
  'view_module',
  'assignment_return',
  'segment',
  'folder_special',
  'format_align_center',
  'calendar_view_month',
  'square',
  'folder_zip',
  'polyline',
  'breaking_news_alt_1',
  'format_align_right',
  'grading',
  'view_headline',
  'linear_scale',
  'edit_off',
  'view_quilt',
  'view_carousel',
  'text_increase',
  'request_page',
  'view_sidebar',
  'text_format',
  'pages',
  'format_align_justify',
  'calendar_view_week',
  'numbers',
  'hexagon',
  'docs_add_on',
  'folder_delete',
  'forms_add_on',
  'format_shapes',
  'imagesearch_roller',
  'calendar_view_day',
  'video_file',
  'font_download',
  'format_list_numbered_rtl',
  'add_to_drive',
  'join_inner',
  'content_paste_go',
  'restore_page',
  'rectangle',
  'format_color_reset',
  'vertical_split',
  'rule_folder',
  'view_stream',
  'cloud_circle',
  'format_indent_increase',
  'spellcheck',
  'data_array',
  'assignment_returned',
  'align_horizontal_left',
  'pivot_table_chart',
  'text_decrease',
  'deselect',
  'pentagon',
  'vertical_align_center',
  'merge_type',
  'space_bar',
  'format_strikethrough',
  'short_text',
  'view_day',
  'flip_to_front',
  'join_left',
  'border_all',
  'shape_line',
  'format_line_spacing',
  'line_weight',
  'horizontal_split',
  'format_indent_decrease',
  'join_right',
  'align_horizontal_center',
  'subtitles_off',
  'snippet_folder',
  'align_vertical_bottom',
  'folder_off',
  'glyphs',
  'format_clear',
  'align_horizontal_right',
  'function',
  'vertical_distribute',
  'insert_page_break',
  'content_paste_off',
  'line_axis',
  'superscript',
  'horizontal_distribute',
  'line_style',
  'flip_to_back',
  'align_vertical_center',
  'align_vertical_top',
  'counter_1',
  'margin',
  'clarify',
  'wrap_text',
  'subscript',
  'view_array',
  'ink_pen',
  'border_style',
  'border_clear',
  'ink_eraser',
  'amp_stories',
  'border_outer',
  'type_specimen',
  'newsmode',
  'text_rotate_vertical',
  'padding',
  'forms_apps_script',
  'border_vertical',
  'text_rotation_none',
  'format_textdirection_l_to_r',
  'ink_highlighter',
  'docs_apps_script',
  'format_overline',
  'finance_chip',
  'border_horizontal',
  'font_download_off',
  'format_textdirection_r_to_l',
  'news',
  'text_rotation_angleup',
  'border_bottom',
  'text_rotation_down',
  'border_inner',
  'border_left',
  'border_top',
  'assignment_add',
  'text_rotation_angledown',
  'equal',
  'text_rotate_up',
  'border_right',
  'format_h1',
  'note_stack_add',
  'frame_inspect',
  'note_stack',
  'join',
  'counter_2',
  'view_column_2',
  'overview',
  'full_coverage',
  'colors',
  'signature',
  'export_notes',
  'slide_library',
  'breaking_news',
  'format_underlined_squiggle',
  'counter_3',
  'format_h2',
  'lab_profile',
  'format_list_bulleted_add',
  'format_paragraph',
  'variables',
  'format_image_left',
  'csv',
  'file_save',
  'reset_image',
  'rubric',
  'width',
  'contract',
  'format_image_right',
  'format_ink_highlighter',
  'ink_marker',
  'draw_abstract',
  'remove_selection',
  'contract_edit',
  'format_h3',
  'text_fields_alt',
  'process_chart',
  'counter_4',
  'dictionary',
  'shapes',
  'format_h5',
  'format_h6',
  'select',
  'unknown_document',
  'voting_chip',
  'add_notes',
  'scan_delete',
  'diagnosis',
  'format_h4',
  'location_chip',
  'stylus_laser_pointer',
  'frame_source',
  'sticky_note',
  'article_shortcut',
  'folder_managed',
  'grid_guides',
  'tab_duplicate',
  'regular_expression',
  'table_chart_view',
  'text_ad',
  'match_case',
  'cell_merge',
  'smb_share',
  'lasso_select',
  'list_alt_add',
  'stock_media',
  'table_rows_narrow',
  'counter_5',
  'business_chip',
  'format_letter_spacing_standard',
  'source_notes',
  'text_select_move_forward_character',
  'ungroup',
  'format_text_overflow',
  'insert_text',
  'line_end_circle',
  'tab_close',
  'book_2',
  'custom_typography',
  'decimal_increase',
  'scan',
  'tab_group',
  'counter_6',
  'line_end_arrow',
  'folder_supervised',
  'ink_highlighter_move',
  'line_end',
  'line_start',
  'thumbnail_bar',
  'format_letter_spacing',
  'format_letter_spacing_2',
  'line_curve',
  'line_end_arrow_notch',
  'draw_collage',
  'stroke_full',
  'contract_delete',
  'counter_0',
  'other_admission',
  'text_select_start',
  'top_panel_close',
  'counter_7',
  'counter_8',
  'counter_9',
  'highlighter_size_3',
  'line_end_square',
  'stroke_partial',
  'text_select_jump_to_beginning',
  'attach_file_add',
  'flex_wrap',
  'heap_snapshot_thumbnail',
  'language_chinese_quick',
  'language_spanish',
  'line_end_diamond',
  'line_start_circle',
  'line_start_diamond',
  'post',
  'fit_width',
  'format_letter_spacing_wide',
  'format_letter_spacing_wider',
  'heap_snapshot_multiple',
  'match_word',
  'person_book',
  'book_5',
  'file_save_off',
  'flex_direction',
  'heap_snapshot_large',
  'ink_eraser_off',
  'language_korean_latin',
  'line_start_arrow',
  'markdown_copy',
  'special_character',
  'tab_move',
  'tab_new_right',
  'top_panel_open',
  'tsv',
  'align_justify_space_around',
  'align_justify_space_between',
  'align_space_between',
  'format_text_clip',
  'frame_reload',
  'language_french',
  'language_international',
  'pageless',
  'pen_size_5',
  'text_select_jump_to_end',
  'text_select_move_forward_word',
  'align_justify_space_even',
  'book_3',
  'folder_data',
  'language_gb_english',
  'language_pinyin',
  'letter_switch',
  'line_start_square',
  'pen_size_2',
  'sheets_rtl',
  'tab_close_right',
  'tab_recent',
  'text_select_move_back_word',
  'text_select_move_up',
  'two_pager',
  'align_center',
  'align_flex_center',
  'book_4',
  'decimal_decrease',
  'fit_page',
  'highlighter_size_5',
  'language_chinese_dayi',
  'language_chinese_wubi',
  'line_start_arrow_notch',
  'pen_size_3',
  'text_select_move_down',
  'align_flex_start',
  'align_justify_center',
  'align_justify_flex_end',
  'align_justify_flex_start',
  'align_self_stretch',
  'align_space_around',
  'align_space_even',
  'asterisk',
  'format_text_wrap',
  'highlighter_size_4',
  'language_chinese_array',
  'language_chinese_cangjie',
  'language_chinese_pinyin',
  'language_us',
  'language_us_colemak',
  'language_us_dvorak',
  'markdown',
  'pen_size_4',
  'text_select_end',
  'text_select_move_back_character',
  'variable_add',
  'align_end',
  'align_flex_end',
  'align_items_stretch',
  'align_justify_stretch',
  'align_start',
  'align_stretch',
  'flex_no_wrap',
  'highlighter_size_1',
  'highlighter_size_2',
  'language_japanese_kana',
  'markdown_paste',
  'pen_size_1',
  'variable_insert',
  'variable_remove',
  'play_arrow',
  'play_circle',
  'mic',
  'videocam',
  'volume_up',
  'pause',
  'music_note',
  'library_books',
  'movie',
  'speed',
  'skip_next',
  'replay',
  'volume_off',
  'pause_circle',
  'view_in_ar',
  'fiber_manual_record',
  'skip_previous',
  'stop_circle',
  'stop',
  'equalizer',
  'subscriptions',
  'video_library',
  'fast_forward',
  'playlist_add',
  'video_call',
  'repeat',
  'volume_mute',
  'shuffle',
  'mic_off',
  'hearing',
  'library_music',
  'podcasts',
  'playlist_add_check',
  'fast_rewind',
  'queue_music',
  'sound_detection_dog_barking',
  'video_camera_front',
  'subtitles',
  'volume_down',
  'play_pause',
  'album',
  'radio',
  'discover_tune',
  'av_timer',
  'library_add_check',
  'videocam_off',
  'closed_caption',
  'stream',
  'forward_10',
  'not_started',
  'replay_10',
  'fiber_new',
  'playlist_play',
  'branding_watermark',
  'text_to_speech',
  'recent_actors',
  'playlist_remove',
  'interpreter_mode',
  'slow_motion_video',
  'frame_person',
  'playlist_add_check_circle',
  'settings_voice',
  'video_settings',
  'featured_play_list',
  'sound_detection_loud_sound',
  'audio_file',
  'lyrics',
  'play_lesson',
  'hd',
  'repeat_one',
  'call_to_action',
  'high_quality',
  'add_to_queue',
  'music_off',
  'video_camera_back',
  'spatial_audio_off',
  'shuffle_on',
  'playlist_add_circle',
  'volume_down_alt',
  'featured_video',
  'hearing_disabled',
  'replay_5',
  'repeat_on',
  'queue_play_next',
  'speech_to_text',
  'spatial_audio',
  'art_track',
  'explicit',
  'airplay',
  '4k',
  'forward_30',
  'forward_5',
  'music_video',
  'replay_30',
  'spatial_tracking',
  'control_camera',
  'closed_caption_disabled',
  'digital_out_of_home',
  'brand_awareness',
  'video_label',
  'fiber_smart_record',
  'play_disabled',
  'repeat_one_on',
  'broadcast_on_personal',
  'sd',
  'missed_video_call',
  'surround_sound',
  'fiber_pin',
  '10k',
  '60fps',
  'sound_detection_glass_break',
  'remove_from_queue',
  'broadcast_on_home',
  'fiber_dvr',
  '30fps',
  '4k_plus',
  'video_stable',
  '8k',
  '1k',
  'instant_mix',
  'privacy',
  '8k_plus',
  '2k',
  '7k',
  '1k_plus',
  '9k_plus',
  '9k',
  '5k',
  '6k',
  '2k_plus',
  '5k_plus',
  '6k_plus',
  '3k',
  '3k_plus',
  '7k_plus',
  'voice_selection',
  'ar_on_you',
  'music_cast',
  'no_sound',
  'video_search',
  'genres',
  'hangout_video',
  'media_link',
  'cinematic_blur',
  'video_camera_front_off',
  'movie_edit',
  'artist',
  'autoplay',
  'resume',
  'mic_double',
  'autopause',
  'forward_media',
  'ar_stickers',
  'movie_info',
  'select_to_speak',
  'audio_description',
  'full_hd',
  '2d',
  'hangout_video_off',
  'autostop',
  'forward_circle',
  'frame_person_off',
  'sound_sampler',
  'view_in_ar_off',
  'local_shipping',
  'directions_car',
  'flight',
  'directions_run',
  'directions_walk',
  'flight_takeoff',
  'directions_bus',
  'train',
  'directions_bike',
  'airport_shuttle',
  'pedal_bike',
  'directions_boat',
  'two_wheeler',
  'agriculture',
  'local_taxi',
  'sailing',
  'electric_car',
  'flight_land',
  'hail',
  'no_crash',
  'commute',
  'motorcycle',
  'car_crash',
  'tram',
  'departure_board',
  'subway',
  'electric_moped',
  'turn_right',
  'electric_scooter',
  'fork_right',
  'directions_subway',
  'tire_repair',
  'electric_bike',
  'rv_hookup',
  'bus_alert',
  'turn_left',
  'transportation',
  'airlines',
  'taxi_alert',
  'u_turn_left',
  'directions_railway',
  'electric_rickshaw',
  'turn_slight_right',
  'u_turn_right',
  'fork_left',
  'railway_alert',
  'bike_scooter',
  'turn_sharp_right',
  'turn_slight_left',
  'no_transfer',
  'snowmobile',
  'turn_sharp_left',
  'flightsmode',
  'swap_driving_apps_wheel',
  'swap_driving_apps',
  'auto_towing',
  'ambulance',
  'auto_transmission',
  'school',
  'campaign',
  'construction',
  'engineering',
  'volunteer_activism',
  'science',
  'sports_esports',
  'confirmation_number',
  'real_estate_agent',
  'cake',
  'self_improvement',
  'sports_soccer',
  'air',
  'biotech',
  'water',
  'hiking',
  'architecture',
  'sports_score',
  'personal_injury',
  'sports_basketball',
  'waves',
  'theaters',
  'sports_tennis',
  'switch_account',
  'nights_stay',
  'sports_gymnastics',
  'how_to_vote',
  'sports_motorsports',
  'backpack',
  'surfing',
  'sports_kabaddi',
  'piano',
  'experiment',
  'sports',
  'toys',
  'sports_volleyball',
  'camping',
  'sports_baseball',
  'sports_martial_arts',
  'swords',
  'downhill_skiing',
  'scoreboard',
  'kayaking',
  'phishing',
  'sports_handball',
  'sports_football',
  'skateboarding',
  'trophy',
  'sports_golf',
  'toys_fan',
  'sports_cricket',
  'nordic_walking',
  'roller_skating',
  'kitesurfing',
  'rowing',
  'scuba_diving',
  'storm',
  'featured_seasonal_and_gifts',
  'sports_mma',
  'paragliding',
  'snowboarding',
  'sports_hockey',
  'ice_skating',
  'snowshoeing',
  'sports_rugby',
  'sledding',
  'family_link',
  'piano_off',
  'no_backpack',
  'rewarded_ads',
  'ifl',
  'steps',
  'sprint',
  'ecg_heart',
  'health_metrics',
  'toys_and_games',
  'mindfulness',
  'readiness_score',
  'cake_add',
  'service_toolbox',
  'exercise',
  'sports_and_outdoors',
  'laps',
  'stress_management',
  'person_celebrate',
  'person_play',
  'floor',
  'newsstand',
  'menstrual_health',
  'azm',
  'pace',
  'relax',
  'distance',
  'avg_pace',
  'bath_private',
  'play_shapes',
  'water_medium',
  'avg_time',
  'interactive_space',
  'water_full',
  'bath_outdoor',
  'onsen',
  'eda',
  'fertile',
  'spo2',
  'podiatry',
  'elevation',
  'bia',
  'cleaning',
  'glass_cup',
  'hr_resting',
  'science_off',
  'bath_public_large',
  'water_loss',
  'check_in_out',
  'monitor_weight_loss',
  'sauna',
  'monitor_weight_gain',
  'physical_therapy',
  'sleep_score',
  'phone_iphone',
  'save',
  'smartphone',
  'print',
  'keyboard_arrow_down',
  'computer',
  'devices',
  'desktop_windows',
  'smart_display',
  'dns',
  'keyboard_backspace',
  'headphones',
  'smart_toy',
  'phone_android',
  'memory',
  'keyboard_arrow_right',
  'keyboard',
  'live_tv',
  'laptop_mac',
  'tv',
  'headset_mic',
  'keyboard_arrow_up',
  'device_thermostat',
  'balance',
  'mouse',
  'route',
  'point_of_sale',
  'keyboard_arrow_left',
  'laptop_chromebook',
  'keyboard_return',
  'watch',
  'power',
  'laptop_windows',
  'router',
  'developer_board',
  'display_settings',
  'scale',
  'cast',
  'book_online',
  'developer_mode',
  'fax',
  'videogame_asset',
  'cast_for_education',
  'device_hub',
  'straight',
  'screen_search_desktop',
  'mobile_friendly',
  'desktop_mac',
  'settings_input_antenna',
  'settings_ethernet',
  'monitor',
  'devices_other',
  'send_to_mobile',
  'important_devices',
  'tablet_mac',
  'dark_mode',
  'badge',
  'apartment',
  'house',
  'stadia_controller',
  'nest_gale_wifi',
];
